/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum NsphSourceEnum {
    InternetSearch = 'INTERNET_SEARCH',
    SocialMedia = 'SOCIAL_MEDIA',
    InternetArticle = 'INTERNET_ARTICLE',
    PressArticle = 'PRESS_ARTICLE',
    Tv = 'TV',
    FamilyFriends = 'FAMILY_FRIENDS',
    Doctor = 'DOCTOR',
    Other = 'OTHER'
}


